import { useMutation, ApolloError, DataProxy } from '@apollo/client';

import { useError } from '@/hooks/useError';
import { useCompanyData } from '@/contexts/CompaniesDataContext';
import { ENTITY_PAGE_FOLLOW_MUTATION } from '@/graphql/mutations';

const useFollowCompanyMutation = ({
  entityPageId,
}: {
  entityPageId: string;
}) => {
  // @ts-expect-error TS(2339) FIXME: Property 'showError' does not exist on type 'unkno... Remove this comment to see the full error message
  const { showError } = useError();
  const { followCompany } = useCompanyData();

  const [handleFollowCompany] = useMutation(ENTITY_PAGE_FOLLOW_MUTATION, {
    update: (cache: DataProxy, props: any) => {
      if (props.data.entityPageFollow?.error) {
        showError({ message: props.data?.entityPageFollow?.error?.message });
      } else {
        followCompany({ entityPageId });
      }
    },
    onError: (error: ApolloError) => {
      showError({ message: error.message, error });
    },
  });

  return {
    handleFollow: () =>
      handleFollowCompany({ variables: { followedId: entityPageId } }),
  };
};

export { useFollowCompanyMutation };
